<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <span
          v-bind="attrs"
          v-on="on"
        >
          {{ item.serial}}
        </span>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Player</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  label="Nombre*"
                  required
                  v-model="name"
                />
              </v-col>
              <v-col
                cols="12"
              >
                <v-text-field
                  label="Descripción*"
                  required
                  v-model="description"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            {{$t('common.close')}}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="handleSave"
          >
            {{$t('common.save')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import api from '@/services/api'
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      dialog: false,
      name: null,
      description: null
    }),
    watch: {
      'item.name' (newValue){
        this.name = newValue
      },
      'item.description' (newValue){
        this.description = newValue
      }
    },
    mounted(){
      this.name = this.item.name
      this.description = this.item.description
    },
    methods: {
      handleSave () {
        //42D92V003107
        const body = {
          name: this.name,
          description: this.description,
          network: this.item.network
        }
        api.updateItem('brightsign/rename', this.item.id, body)
        .then(response => {
          console.log(response)
          alert(this.item.id)
          // this.dialog = false
        })
        this.dialog = false
      }
    }
  }
</script>
